import Vue from 'vue'
import moment from 'moment'
import numeral from 'numeral'
import store from '@/store'

const mixin = {
  methods: {
    $getK3lCategories(value) {
      const categories = store.state.k3lCategories
      if (value && value > 0) {
        if (categories) {
          for (let i in categories) {
            if (
              categories[i].score_min <= value &&
              categories[i].score_max >= value
            )
              return categories[i].desc
          }
        }
      }

      return ''
    },
    $getKplhCategories(value) {
      const categories = store.state.kplhCategories
      if (value && value > 0) {
        if (categories) {
          for (let i in categories) {
            if (
              categories[i].score_min <= value &&
              categories[i].score_max >= value
            )
              return categories[i].desc
          }
        }
      }

      return ''
    },
    afiliationClass(value) {
      let comment = 'Affiliated'
      let afiliated = false
      if (value) {
        if (value.afiliasi_bce && value.afiliasi_bce == 1) {
          comment += ' BCE'
          afiliated = true
        }
        if (value.afiliasi_gems && value.afiliasi_gems == 1) {
          comment += ' GEMS'
          afiliated = true
        }
        if (value.afiliasi_bkes && value.afiliasi_bkes == 1) {
          comment += ' BKES'
          afiliated = true
        }

        if (afiliated) {
          return comment
        }
      }

      return 'Non Affiliated'
    },
    formatDate(value) {
      if (
        value &&
        moment(value).isValid() &&
        moment(value).format('DD MMM YYYY') !== '01 Jan 1970'
      ) {
        return moment(value).format('DD MMM YYYY')
      }
      return '-'
    },
    formatNumberDate(value) {
      if (
        value &&
        moment(value).isValid() &&
        moment(value).format('DD/MM/YYYY') !== '01/01/1979'
      ) {
        return moment(value).format('DD/MM/YYYY')
      }
      return '-'
    },
    formatDateInput(value) {
      if (value && moment(value).isValid()) {
        return moment(value).format('yyyy-MM-DD')
      }
    },
    formatFullDate(value) {
      if (
        value &&
        moment(value).isValid() &&
        moment(value).format('DD MMM YYYY') !== '01 Jan 1970'
      ) {
        return moment(value).format('DD - MMMM - YYYY')
      }
      return '-'
    },
    fancyDate(value) {
      if (
        value &&
        moment(value).isValid() &&
        moment(value).format('DD MMM YYYY') !== '01 Jan 1970'
      ) {
        return moment(value).format("MMM 'YY")
      }
      return '-'
    },
    daysDuration(value) {
      if (value && moment(value).isValid()) {
        let start = moment()
        let end = moment(value, moment.ISO_8601)

        return moment
          .duration(start.diff(end))
          .asDays()
          .toFixed(0)
      }
      return '-'
    },
    monthDuration(value) {
      if (value && moment(value).isValid()) {
        let start = moment()
        let end = moment(value, moment.ISO_8601)

        return moment
          .duration(start.diff(end))
          .asMonths()
          .toFixed(0)
      }
      return '-'
    },
    monthFromNow(value) {
      let subtract = moment()
        .subtract(value, 'months')
        .format('YYYY-MM-DD')

      return subtract
    },
    $now() {
      return moment().format('YYYY-MM-DD')
    },

    monthConverter(value) {
      switch (value) {
        case 1:
          return 'Jan'
          break
        case 2:
          return 'Feb'
          break
        case 3:
          return 'Mar'
          break
        case 4:
          return 'Apr'
          break
        case 5:
          return 'Mei'
          break
        case 6:
          return 'Jun'
          break
        case 7:
          return 'Jul'
          break
        case 8:
          return 'Agt'
          break
        case 9:
          return 'Sep'
          break
        case 10:
          return 'Okt'
          break
        case 11:
          return 'Nov'
          break
        case 12:
          return 'Des'
          break

        default:
          break
      }
    },
    twoDigitYear(value) {
      if (value) {
        let digit = String(value).split('')

        return `${digit[2]}${digit[3]}`
      }

      return '-'
    },

    convertNumberDescimal(value) {
      if (value) {
        return Number(value).toFixed(2)
      }

      return 0
    },
    curencyDelimiter(value) {
      if (value && value !== '') {
        let idr = numeral(value).format('0,0.00')
        let newIdr = ''
        idr.split('').map(list => {
          if (list == ',') {
            newIdr += '.'
          } else if (list == '.') {
            newIdr += ','
          } else {
            newIdr += list
          }
        })
        return newIdr
      }
      return '0.00'
    },

    generateInitial(value) {
      let text = value
      text = value.replace(/[(!@#$%^&*)]/gi, '')
      let arr = text.split(' ')
      let initial = []

      if (arr.length > 1) {
        for (let i = 0; i < 2; i++) {
          initial.push(arr[i][0])
        }
        return initial.join('')
      }

      return text[0].toUpperCase()
    },
    generateInitialChart(value) {
      let text = value
      text = value.replace(/[0-9()_-]/gi, ' ')
      let arr = text.split(' ')
      let initial = []

      if (arr.length > 1) {
        for (let i = 0; i < 4; i++) {
          initial.push(arr[i][0])
        }
        return initial.join('').toUpperCase()
      }

      return text[0]
    },
    checkTotalInitial(value) {
      let arr = value.split(' ')

      return arr.length < 2 ? 1 : 2
    },

    kinerjaPoRating(value, position) {
      if (value) {
        let num = Number(value).toFixed(2)
        if (num > 0 && num < 1.5) return 1 >= position
        if (num >= 1.5 && num < 2.5) return 2 >= position
        if (num >= 2.5 && num < 3.5) return 3 >= position
        if (num >= 3.5 && num < 4.5) return 4 >= position
        if (num >= 4.5 && num <= 5) return 5 >= position
      }

      return 0
    },

    kinerjaKontrakRating(value, position) {
      if (value) {
        let num = Number(value).toFixed(1)
        if (num > 0 && num < 29.1) return 1 >= position
        if (num >= 29.1 && num < 49.1) return 2 >= position
        if (num >= 49.1 && num < 69.1) return 3 >= position
        if (num >= 69.1 && num < 89.1) return 4 >= position
        if (num >= 89.1 && num <= 100) return 5 >= position
      }

      return false
    },
    k3lKplhCategory(score) {
      if (typeof score == 'number') {
        if (score <= 20) return 'LOW C2'
        if (score > 21 && score <= 35) return 'LOW C1'
        if (score > 35 && score <= 50) return 'MEDIUM B2'
        if (score > 50 && score <= 80) return 'MEDIUM B1'
        if (score > 80 && score <= 100) return 'HIGH A'
      }
      return '-'
    },
    csiCategory(value) {
      const num = Math.round(value)
      if (num && num > 0) {
        if (num > 0 && num < 1.5) return 'Sangat Buruk'
        if (num >= 1.5 && num < 2.5) return 'Tidak Memuaskan'
        if (num >= 2.5 && num < 3.5) return 'Cukup Memuaskan'
        if (num >= 3.5 && num < 4.5) return 'Memuaskan'
        if (num >= 4.5 && num <= 5) return 'Sangat Memuaskan'
      }
      return '-'
    },
    requestCsi(value) {
      const num = Math.round(value)
      if (num && num > 0) {
        switch (num) {
          case 1:
            return 'Sangat Tidak Puas'
            break
          case 2:
            return 'Tidak Puas'
            break
          case 3:
            return 'Netral'
            break
          case 4:
            return 'Puas'
            break
          case 5:
            return 'Sangat Puas'
            break

          default:
            return 'Belum Ada Penilaian'
            break
        }
      }
      return '-'
    },
    spmCategory(score) {
      if (score >= 89.1 && score <= 100) {
        return 'Sangat Memuaskan'
      } else if (score >= 69.1 && score < 89.1) {
        return 'Memuaskan'
      } else if (score >= 49.1 && score < 69.1) {
        return 'Cukup Memuaskan'
      } else if (score >= 29.1 && score < 49.1) {
        return 'Tidak Memuaskan'
      } else if (score > 0 && score < 29.1) {
        return 'Sangat Buruk'
      } else {
        return '-'
      }
    },
    paramsFormatter(name, array) {
      let newParams = []
      if (array && array.length > 0) {
        for (let i in array) {
          newParams.push(`&${name}[]=${array[i]}`)
        }

        return newParams.join('')
      }
    },
    $get(obj, path, defaultValue = null) {
      let result = obj
      for (let piece of path.split('.')) {
        result = result[piece]
        if (!result || typeof result !== 'object') {
          return result || defaultValue
        }
      }
      return defaultValue
    },
    $sortAsc(a, b) {
      if (a.id < b.id) {
        return -1
      }
      if (a.id > b.id) {
        return 1
      }
      return 0
    },
    $sortDesc(a, b) {
      if (a.id > b.id) {
        return -1
      }
      if (a.id < b.id) {
        return 1
      }
      return 0
    },

    $linkConverter(value) {
      if (value) {
        let splitResult = value.split('\\')
        return splitResult[splitResult.length - 1]
      }
      return '-'
    },

    requestType(value) {
      switch (value) {
        case 1:
          return 'Vendor Baru'
          break
        case 2:
          return 'Extend to SAP'
          break
        case 3:
          return 'Block Vendor'
          break
        case 4:
          return 'Unblock Vendor'
          break
        case 5:
          return 'Praqualifikasi'
          break
        case 6:
          return 'Vendor Deleted'
          break
        case 7:
          return 'Penilaian Praqualifikasi K3l'
          break
        case 8:
          return 'Penilaian Praqualifikasi KPLH'
          break
        case 9:
          return 'Praqualifikasi Data Legal'
          break
        case 10:
          return 'Praqualifikasi K3L'
          break
        case 11:
          return 'Praqualifikasi KPLH'
          break

        default:
          break
      }
    },
    requestStatus(value) {
      switch (value) {
        case 1:
          return 'Created'
          break
        case 2:
          return 'Waiting for SIPM Approve' // sipm
          break
        case 3:
          return 'Waiting for Ticket Review'
          break
        case 4:
          return 'Ticket Rejected'
          break
        case 5:
          return 'Ticket Approved'
          break
        case 6:
          return 'Waiting for Vendor Feedback' // if simp create request, same sipm cant approve that request
          break
        case 7:
          return 'Vendor Feedback'
          break
        case 8:
          return 'Waiting for Validation' // sipm
          break
        case 9:
          return 'Waiting for Head SIPM Approve' // head sipm
          break
        case 10:
          return 'Postpone'
          break
        case 11:
          return 'Vendor Rejected'
          break
        case 12:
          return 'Vendor Approved'
          break
        case 13:
          return 'Vendor Registered'
          break
        case 14:
          return 'Vendor Deleted'
          break
        case 15:
          return 'Waiting for Operational Compliance Check'
          break
        case 16:
          return 'Waiting for Head Operational Compliance Check'
          break
        case 17:
          return 'K3L Approved'
          break
        case 18:
          return 'Waiting for HSE Check'
          break
        case 19:
          return 'Waiting for Head HSE Check'
          break
        case 20:
          return 'Waiting for KTT Check'
          break
        case 21:
          return 'KPLH Approved'
          break

        default:
          return 'Revise Now'
          break
      }
    },
    isValidationPage(status) {
      if (status == 8 || status == 9 || status == 12) {
        return true
      }

      return false
    },
    requestListValidation(status) {
      if (status == 8 || status == 12) {
        return true
      }

      return false
    },
    firstRoute(value) {
      let route = ''

      if (value && value.split('/')) {
        route = value.split('/')[1]
      }

      return route
    },
    $sum(items, name) {
      if (items) {
        return items.reduce(function(a, b) {
          return a + Number(b[name])
        }, 0)
      }
    },
    isEmailValid(text) {
      return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/.test(text)
    },
    imageFileValidation(text) {
      //png,jpg, jpeg, BMP
      return /^.*\.(jpg|JPG|png|PNG|jpeg|JPEG|bmp|BMP)$/.test(text)
    },

    multiConditions(conditions) {
      for (let i = 0; i < conditions.length; i++) {
        if (conditions[i][0]) {
          // do nothing
        } else {
          store.commit(
            'SET_NOTIF',
            `Silahkan mengisi ${conditions[i][1]} dengan benar.`
          )
          return false
        }
      }
      return true
    },

    multiCustomConditions(conditions) {
      for (let i = 0; i < conditions.length; i++) {
        if (conditions[i][0]) {
          // do nothing
        } else {
          store.commit('SET_NOTIF', `${conditions[i][1]}`)
          return false
        }
      }
      return true
    },
  },
}

Vue.mixin(mixin)

export { mixin }
